<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商机分类</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
              size="mini"
            >
            <el-form-item >
              <el-input v-model="searchForm.name" placeholder="请输入商机分类" p clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        </el-row>

      <!-- 表格 -->
      <el-table
         ref="multipleTable"
        :data="tableLoadData"
         height="450"
         row-key="id"
         border
         size="mini"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column :index="indexMethod" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column
          label="分类名称"
          prop="name"
        >
        </el-table-column>
        <el-table-column
          label="排序"
          prop="sort"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="handelDel(scope.row)">删除</el-button>
            <el-button @click="handelEdit(scope.row)" size="mini" type="text">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" :rules="rules" ref="form" label-width="80px" size="mini">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="ruleForm.name" autocomplete="off" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="上级分类">
          <el-select v-model="ruleForm.parent_id" style="width: 200px;" clearable placeholder="请选择分类"  @change="handleIsopenSelect">
            <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="ruleForm.sort" autocomplete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "demandCategoryList",
    components: {
    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入分类名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            {
              min: 1,
              max: 30,
              message: "长度在 1 到 30 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        ruleForm: {
          name: '',
          parent_id:'',
          id:'',
          sn:"",
          sort:1,
        },
        cateMenus:[],

      };
    },
    created() {

      this.DataList()
     // this.departData();
      this.getCateMenus();
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {

      handleIsopenSelect(){

      },
      getCateMenus(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
         // shop_id:sessionStorage.getItem('shop_id')
        };
        this.$axios.demandCategoryTable(params).then((res)=>{
          if(res.code == 200) {
            _this.cateMenus=res.data;
          }
        });

      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
         // shop_id: sessionStorage.getItem('shop_id')
          // page: this.pageNum,
          // pageSize: this.pageSize,
        }
        this.$axios.demandCategoryTree(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data

          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.title = '新增'
        this.ruleForm.id ='';
        this.ruleForm.name ="";
        this.ruleForm.parent_id = "";
        this.dialogFormVisible = true
      },
      handelEdit(row) {
        this.ruleForm.id = row.id
        this.ruleForm.name = row.name;
        this.ruleForm.parent_id = row.pid;
        this.ruleForm.sort = row.sort;
        this.title = '编辑'
        this.dialogFormVisible = true
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
              const param = {
                name: this.ruleForm.name,
                id:this.ruleForm.id,
                pid: this.ruleForm.parent_id,
                sort: this.ruleForm.sort,
                shop_id:sessionStorage.getItem("shop_id"),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.demandCategorySave(param).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }
        })
      },
      // searchSubmit() {
      //   const param = {
      //       queryParams: this.searchForm.name,
      //       company_id:sessionStorage.getItem('company_id'),
      //       access_token:sessionStorage.getItem('token'),
      //       page: this.pageNum,
      //       pageSize: this.pageSize
      //   }
      //   this.$refs.searchForRef.validate((valid) => {
      //     if (valid) {
      //       this.$axios.insuranceCorpList(param).then(res=>{
      //         if(res.code == 200){
      //           this.tableLoadData = res.data.data
      //           this.total = res.data.total
      //         }
      //       })
      //     }
      //   })
      // },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          this.$axios.demandCategoryDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })

        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
